export enum RecoilStateEnum {
  HAS_VALUE = 'hasValue',
  LOADING = 'loading',
  HAS_ERROR = 'hasError',
}
